import type { PropsWithChildren, ReactNode } from "react";

import { Popover, PopoverTrigger } from "@similarweb/ui-components";

import { StyledPopoverContent } from "./styles";

type Props = PropsWithChildren<{
    content: ReactNode;
}>;

const SearchQuotaPopover = ({ children, content }: Props) => {
    return (
        <Popover
            placement="top"
            withArrow
            isHover
        >
            <PopoverTrigger asChild>
                <div>{children}</div>
            </PopoverTrigger>

            <StyledPopoverContent>{content}</StyledPopoverContent>
        </Popover>
    );
};

export default SearchQuotaPopover;
